import { render, staticRenderFns } from "./referralLayout.vue?vue&type=template&id=2b30a50e&"
import script from "./referralLayout.vue?vue&type=script&lang=js&"
export * from "./referralLayout.vue?vue&type=script&lang=js&"
import style0 from "./referralLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports